import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { getTrialStatus } from "@/utils/trialUtils";
import { useUpgradeHandler } from "@/services/upgradeService";
import { NOTIFICATION_THRESHOLDS } from "@/services/notificationService";

export const TrialConversionDialog = () => {
  const [open, setOpen] = useState(false);
  const { handleUpgrade } = useUpgradeHandler();
  
  useEffect(() => {
    const status = getTrialStatus();
    const lastPrompt = localStorage.getItem('lastConversionPrompt');
    const shouldShowPrompt = status.isActive && 
      status.daysRemaining <= NOTIFICATION_THRESHOLDS.WARNING && 
      (!lastPrompt || Date.now() - parseInt(lastPrompt) > 24 * 60 * 60 * 1000);

    if (shouldShowPrompt) {
      setOpen(true);
      localStorage.setItem('lastConversionPrompt', Date.now().toString());
    }
  }, []);

  const handleUpgradeClick = async () => {
    setOpen(false);
    await handleUpgrade('premium');
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Upgrade Your Plan</DialogTitle>
          <DialogDescription>
            Don't lose access to these valuable features:
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <ul className="list-disc pl-4 space-y-2">
            <li>Continuous cognitive assessment tracking</li>
            <li>Family monitoring tools</li>
            <li>24/7 support access</li>
            <li>Advanced care coordination</li>
          </ul>
          <p className="text-sm text-muted-foreground">
            Lock in our current pricing by upgrading now!
          </p>
        </div>
        <div className="flex justify-end space-x-4">
          <Button variant="outline" onClick={() => setOpen(false)}>
            Remind Me Later
          </Button>
          <Button onClick={handleUpgradeClick}>
            Upgrade Now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};